import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  get pathname(): string {
    return window.location.pathname;
  }

  get search(): string {
    return window.location.search;
  }

  get href(): string {
    return window.location.href;
  }
}
